<label [for]="id()">{{ label() }}</label>
@if (type() !== 'select') {
  <input [formControl]="inputControl" [placeholder]="placeholder()" [id]="id()" [type]="type()">
} @else {
  <select [formControl]="inputControl" [id]="id()">
    <option value="" disabled>{{ placeholder() }}</option>
    @for (option of options(); track option) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>
}

@if (type() === 'tel' && showTelError() && inputControl.touched) {
  <p class="error">
    <fa-icon icon="exclamation-triangle"/>
    Must be a valid E.164 phone (e.g. +15551234567)
  </p>
}
